import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTheme } from '../../../../stores/actions/themes';
import { setModalOpen } from '../../../../stores/actions/modal';
import { GreenroomState } from '../../../../stores/types/types';
import { DeleteTheme } from '../../../../connection/themes';
import { RegenerateStaleContentForMeeting } from '../../../../connection/generate-content';
import logger from '../../../../utils/logger-rum';

export default function DeleteThemeModal() {
	const modalData = useSelector((state: GreenroomState) => state.ModalReducer.modalData);
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting?.meeting);
	const {theme: {name, colors, id}, channel} = modalData;
	const dispatch = useDispatch();

	const confirmDeleteTheme = async () => {
		if (Number.isNaN(channel + id)) {
			return logger.error('NaN channel', channel, 'or theme id', id)
		}
		const { deleted, newThemeIds } = await DeleteTheme(channel, id);
		if (deleted) {
			dispatch(deleteTheme(id));
			dispatch(setModalOpen(false));
			if (meeting) {
				RegenerateStaleContentForMeeting(meeting, { themeIds: newThemeIds });
			}
		}
	}

	return (
		<div className="info-modal confirmation-dialog delete-event" data-testid="delete-account-modal">
			<h4 className='bl-font-header' style={{margin: 0}}>Do you want to delete this style?</h4>
			<div className="text-content bl-font-p1" style={{margin: '16px 0 24px 0'}}>
				This action can't be undone.
			</div>
			<div className="button-group">
				<button className="button-pillbox dullgray" onClick={confirmDeleteTheme} data-testid="delete-account-btn">
					<span>Confirm</span>
				</button>
				<button className="button-pillbox confirm" onClick={() => dispatch(setModalOpen(false))}>
					Cancel
				</button>
			</div>
		</div>
	);
}